var convert = require('convert-units')

export const converter = {

  imperialToMetric: {
    "inch": val => (Number(val)*25.4),
    "lb/inch3": val => Number(val*27679.9),
    "in2": val => Number(convert(val).from('in2').to('mm2')),
    "lb": val => (Number(val)*453.59237),
    labels: {
      "inch": "mm",
      "lb/inch3": "kg/m3",
      "in2": "mm2",
      "lb": "g",
    }
  },
  metricToImperial: {
    "mm": val => (Number(val)/25.4),
    "kg/m3": val => Number(val*0.000036),
    "mm2": val => Number(convert(val).from('mm2').to('in2')), 
    "g": val => (Number(val)/453.59237),
    labels:{
      "mm": "in",
      "kg/m3": "lb/inch3",
      "mm2": "in2",
      "g": "lb"
    }
  }
};
